// import React, { useLayoutEffect } from 'react';
// import PropTypes from 'prop-types';
// import * as am5 from '@amcharts/amcharts5';
// import * as am5xy from '@amcharts/amcharts5/xy';
// import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
// import Wrapper from '../../helpers/Wrapper';

// // Helper: Make label user-friendly (store_type -> Store Type, sub_category -> Sub Category, etc)
// function prettifyLabel(str) {
//   if (!str) return "";
//   return str
//     .replace(/_/g, " ")
//     .replace(/\b\w/g, c => c.toUpperCase());
// }

// const HeatRiskGrowth = ({
//   chartId,
//   chartClass,
//   yAxisLabels,
//   xAxisLabels,
//   data,
//   valueFieldName,
// }) => {
//   useLayoutEffect(() => {
//     const root = am5.Root.new(chartId);
//     root.setThemes([am5themes_Animated.new(root)]);

//     const chart = root.container.children.push(
//       am5xy.XYChart.new(root, {
//         panX: false,
//         panY: false,
//         wheelX: 'none',
//         wheelY: 'none',
//         paddingLeft: 0,
//         paddingRight: 0,
//         layout: root.verticalLayout,
//       })
//     );

//     const yRenderer = am5xy.AxisRendererY.new(root, {
//       minGridDistance: 0,
//       cellHeight: 40,
//     });
//     const yAxis = chart.yAxes.push(
//       am5xy.CategoryAxis.new(root, {
//         renderer: yRenderer,
//         categoryField: 'y',
//       })
//     );

//     const xRenderer = am5xy.AxisRendererX.new(root, {
//       minGridDistance: 0,
//       opposite: true,
//     });
//     const xAxis = chart.xAxes.push(
//       am5xy.CategoryAxis.new(root, {
//         renderer: xRenderer,
//         categoryField: 'x',
//       })
//     );

//     const series = chart.series.push(
//       am5xy.ColumnSeries.new(root, {
//         xAxis,
//         yAxis,
//         categoryXField: 'x',
//         categoryYField: 'y',
//         valueField: valueFieldName,
//         clustered: false,
//       })
//     );

//     series.columns.template.setAll({
//       width: am5.percent(100),
//       height: am5.percent(100),
//       stroke: am5.color(0xffffff),
//       strokeWidth: 1,
//       cornerRadiusTL: 5,
//       cornerRadiusTR: 5,
//       cornerRadiusBL: 5,
//       cornerRadiusBR: 5,
//       templateField: 'columnSettings',
//     });

//     root.numberFormatter.setAll({
//       numberFormat: "#.##a",
//       bigNumberPrefixes: [
//         { number: 1e3, suffix: "K" },
//         { number: 1e6, suffix: "M" },
//         { number: 1e9, suffix: "B" },
//       ],
//       smallNumberPrefixes: [],
//     });

//     // --- Custom Tooltip Design ---
//     const styledTooltip = am5.Tooltip.new(root, {
//       pointerOrientation: "horizontal",
//       getFillFromSprite: false,
//       getStrokeFromSprite: false,
//       autoTextColor: false,
//     });
//     styledTooltip.label.setAll({
//       fill: am5.color(0xffffff),
//       fontSize: 14,
//       fontFamily: "Ubuntu, sans-serif",
//       oversizedBehavior: "wrap",
//       maxWidth: 300,
//     });
//     styledTooltip.get("background").setAll({
//       fill: am5.color(0x213345),
//       fillOpacity: 0.85,
//       cornerRadius: 5,
//       stroke: am5.color(0x213345),
//     });

//     series.columns.template.set("tooltip", styledTooltip);

//     // Adapter for tooltip text (use prettified keys)
//     series.columns.template.adapters.add("tooltipText", (text, target) => {
//       const ctx = target.dataItem?.dataContext;
//       if (!ctx) return "";

//       // Use the raw field names for exact match, but display prettified label
//       let yLabel = prettifyLabel(yAxisLabels.label); // e.g. Sub Category
//       let xLabel = prettifyLabel(xAxisLabels.label); // e.g. Store Type
//       let valueLabel = prettifyLabel(valueFieldName); // e.g. Sales Value, Sales Value Growth

//       // Format value as percent if valueLabel contains "growth", else as normal number
//       let value = ctx[valueFieldName];
//       let valueFormatted = typeof value === "number"
//         ? `${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${valueLabel.toLowerCase().includes("growth") ? "%" : ""}`
//         : value;

//       return (
//         `[font-size:12px][#ffffff]●[/] ${yLabel}: [b][#ffffff]${ctx.y}[/]\n` +
//         `[font-size:12px][#ffffff]●[/] ${xLabel}: [b][#ffffff]${ctx.x}[/]\n` +        
//         `[font-size:12px][#ffffff]●[/] ${valueLabel}: [b][#ffffff]${valueFormatted}[/]`
//       );
//     });

//     // Map whatever field was chosen into each data point:
//     const formattedData = data.map(item => ({
//       y: item.y,
//       x: item.x,
//       [valueFieldName]: typeof item[valueFieldName] === 'number'
//         ? item[valueFieldName]
//         : 0,
//       columnSettings: {
//         fill: item.color ? am5.color(item.color) : am5.color('#CCCCCC'),
//       },
//     }));

//     yAxis.data.setAll(yAxisLabels.values.map(label => ({ y: label })));
//     xAxis.data.setAll(xAxisLabels.values.map(label => ({ x: label })));
//     series.data.setAll(formattedData);
//     chart.appear(1000, 100);

//     return () => root.dispose();
//   }, [chartId, yAxisLabels, xAxisLabels, data, valueFieldName]);

//   return (
//     <Wrapper>
//       <div
//         id={chartId}
//         className={chartClass}
//         style={{ height: '500px', width: '100%' }}
//       />
//       {/* Custom Legend Bar */}
//       <div style={{ width: '80%', margin: '32px auto 0 auto' }}>
//         <div
//           style={{
//             display: 'flex',
//             height: 14,
//             borderRadius: 4,
//             textAlign: 'center',
//             overflow: 'hidden',
//             boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
//           }}
//         >
//           <div style={{ flex: 1, background: '#FF7F8A' }} />
//           <div style={{ flex: 1, background: '#FFBE7B' }} />
//           <div style={{ flex: 1, background: '#07C180' }} />
//         </div>
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             marginTop: 6,
//             fontSize: 14,
//             color: '#b2bac6',
//             fontWeight: 400,
//           }}
//         >
//           <span style={{ flex: 1, textAlign: 'left' }}>&lt;0%</span>
//           <span style={{ flex: 1, textAlign: 'center' }}>0% - 10%</span>
//           <span style={{ flex: 1, textAlign: 'right' }}>&gt;10%</span>
//         </div>
//       </div>
//     </Wrapper>
//   );
// };

// HeatRiskGrowth.propTypes = {
//   chartId: PropTypes.string.isRequired,
//   chartClass: PropTypes.string,
//   yAxisLabels: PropTypes.shape({
//     label: PropTypes.string.isRequired,
//     values: PropTypes.arrayOf(PropTypes.string).isRequired,
//   }).isRequired,
//   xAxisLabels: PropTypes.shape({
//     label: PropTypes.string.isRequired,
//     values: PropTypes.arrayOf(PropTypes.string).isRequired,
//   }).isRequired,
//   data: PropTypes.arrayOf(
//     PropTypes.shape({
//       y: PropTypes.string.isRequired,
//       x: PropTypes.string.isRequired,
//       color: PropTypes.string,
//     })
//   ).isRequired,
//   valueFieldName: PropTypes.string.isRequired,
// };

// export default HeatRiskGrowth;



import React, { useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import Wrapper from '../../helpers/Wrapper';
import { formatNumberForTooltip } from "../../../utils/NumberFormatter";

// Helper: Make label user-friendly (store_type -> Store Type, sub_category -> Sub Category, etc)
function prettifyLabel(str) {
  if (!str) return "";
  return str
    .replace(/_/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());
}

const HeatRiskGrowth = ({
  chartId,
  chartClass,
  yAxisLabels,
  xAxisLabels,
  data,
  valueFieldName,
}) => {
  // Keep a persistent reference to the chart root
  const chartRoot = useRef(null);

  useLayoutEffect(() => {
    // Dispose previous root if it exists
    if (chartRoot.current) {
      chartRoot.current.dispose();
      chartRoot.current = null;
    }

    // Create new root
    chartRoot.current = am5.Root.new(chartId);
    const root = chartRoot.current;

    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: 'none',
        wheelY: 'none',
        paddingLeft: 0,
        paddingRight: 0,
        layout: root.verticalLayout,
      })
    );

    const yRenderer = am5xy.AxisRendererY.new(root, {
      minGridDistance: 0,
      cellHeight: 40,
    });
    const yAxis = chart.yAxes.push(
      am5xy.CategoryAxis.new(root, {
        renderer: yRenderer,
        categoryField: 'y',
      })
    );
    yAxis.get("renderer").labels.template.setAll({
      fontSize: 13,
      fontFamily: "Ubuntu, sans-serif",
      fill: am5.color(0x757575), // label color
      fontWeight: "400",
      oversizedBehavior: "truncate",
      maxWidth: 120,
    });

    const xRenderer = am5xy.AxisRendererX.new(root, {
      minGridDistance: 0,
      opposite: true,
    });
    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        renderer: xRenderer,
        categoryField: 'x',
      })
    );
    xAxis.get("renderer").labels.template.setAll({
      fontSize: 13,
      fontFamily: "Ubuntu, sans-serif",
      fill: am5.color(0x757575), // label color
      fontWeight: "400",
      oversizedBehavior: "truncate",
      maxWidth: 120,
      tooltipText: "{x}"
    });


    xAxis.get("renderer").labels.template.adapters.add("text", (text, target) => {
      // Use dataItem to get the original label if available
      const dataItem = target.dataItem;
      if (dataItem && dataItem.dataContext && dataItem.dataContext.x) {
        const label = dataItem.dataContext.x;
        return label.length > 8 ? label.slice(0, 8) + "..." : label;
      }
      // fallback for plain string
      if (typeof text === "string" && text.length > 8) {
        return text.slice(0, 8) + "...";
      }
      return text;
    });
    xAxis.get("renderer").labels.template.setAll({
      tooltipText: "{x}"
    });

    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        xAxis,
        yAxis,
        categoryXField: 'x',
        categoryYField: 'y',
        valueField: valueFieldName,
        clustered: false,
      })
    );

    series.columns.template.setAll({
      width: am5.percent(100),
      height: am5.percent(100),
      stroke: am5.color(0xffffff),
      strokeWidth: 1,
      cornerRadiusTL: 5,
      cornerRadiusTR: 5,
      cornerRadiusBL: 5,
      cornerRadiusBR: 5,
      templateField: 'columnSettings',
    });

    root.numberFormatter.setAll({
      numberFormat: "#.##a",
      bigNumberPrefixes: [
        { number: 1e3, suffix: "K" },
        { number: 1e6, suffix: "M" },
        { number: 1e9, suffix: "B" },
      ],
      smallNumberPrefixes: [],
    });

    // --- Custom Tooltip Design ---
    const styledTooltip = am5.Tooltip.new(root, {
      pointerOrientation: "horizontal",
      getFillFromSprite: false,
      getStrokeFromSprite: false,
      autoTextColor: false,
    });
    styledTooltip.label.setAll({
      fill: am5.color(0xffffff),
      fontSize: 12,
      fontFamily: "Ubuntu",
      fontWeight: "bold", // ensures all text is bold
      oversizedBehavior: "wrap",
      maxWidth: 300,
    });
    styledTooltip.get("background").setAll({
      fill: am5.color(0x213345),
      fillOpacity: 0.85,
      cornerRadius: 5,
      stroke: am5.color(0x213345),
    });

    series.columns.template.set("tooltip", styledTooltip);

    // Adapter for tooltip text (use prettified keys)
    series.columns.template.adapters.add("tooltipText", (text, target) => {
      const ctx = target.dataItem?.dataContext;
      if (!ctx) return "";

      let yLabel = prettifyLabel(yAxisLabels.label);
      let xLabel = prettifyLabel(xAxisLabels.label);
      let valueLabel = prettifyLabel(valueFieldName);

      let value = ctx[valueFieldName];
      let valueFormatted = typeof value === "number"
        ? formatNumberForTooltip(value, valueLabel)
        : value;

      return (
        `● ${yLabel}: ${ctx.x}\n` +
        `● ${xLabel}: ${ctx.y}\n` +
        `● ${valueLabel}: ${valueFormatted}`
      );
    });

    // Map whatever field was chosen into each data point:
    const formattedData = data.map(item => ({
      y: item.y,
      x: item.x,
      [valueFieldName]: typeof item[valueFieldName] === 'number'
        ? item[valueFieldName]
        : 0,
      columnSettings: {
        fill: item.color ? am5.color(item.color) : am5.color('#CCCCCC'),
      },
    }));

    yAxis.data.setAll(yAxisLabels.values.map(label => ({ y: label })));
    xAxis.data.setAll(xAxisLabels.values.map(label => ({ x: label })));
    series.data.setAll(formattedData);
    chart.appear(1000, 100);

    // Cleanup on unmount or before re-run
    return () => {
      if (chartRoot.current) {
        chartRoot.current.dispose();
        chartRoot.current = null;
      }
    };
  }, [chartId, yAxisLabels, xAxisLabels, data, valueFieldName]);

  return (
    <Wrapper>
      <div
        id={chartId}
        className={chartClass}
        style={{ height: '500px', width: '100%' }}
      />
      {/* Custom Legend Bar */}
      <div style={{ width: '80%', margin: '32px auto 0 auto' }}>
        <div
          style={{
            display: 'flex',
            height: 12,
            width: "auto",
            borderRadius: 4,
            textAlign: 'center',
            overflow: 'hidden',
            boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
          }}
        >
          <div style={{ flex: 1, background: '#FF7F8A' }} />
          <div style={{ flex: 1, background: '#FFBE7B' }} />
          <div style={{ flex: 1, background: '#07C180' }} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 6,
            fontSize: 12,
            // color: '#b2bac6',
            fill: am5.color(0x213345),
            fontWeight: 400,
          }}
        >
          <span style={{ flex: 1, textAlign: 'left' }}>&lt;0%</span>
          <span style={{ flex: 1, textAlign: 'center' }}>0% - 10%</span>
          <span style={{ flex: 1, textAlign: 'right' }}>&gt;10%</span>
        </div>
      </div>
    </Wrapper>
  );
};

HeatRiskGrowth.propTypes = {
  chartId: PropTypes.string.isRequired,
  chartClass: PropTypes.string,
  yAxisLabels: PropTypes.shape({
    label: PropTypes.string.isRequired,
    values: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  xAxisLabels: PropTypes.shape({
    label: PropTypes.string.isRequired,
    values: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      y: PropTypes.string.isRequired,
      x: PropTypes.string.isRequired,
      color: PropTypes.string,
    })
  ).isRequired,
  valueFieldName: PropTypes.string.isRequired,
};

export default HeatRiskGrowth;